import { render } from "./DijiaNumberPoolSource.vue?vue&type=template&id=efc3c83c&scoped=true"
import script from "./DijiaNumberPoolSource.vue?vue&type=script&lang=js"
export * from "./DijiaNumberPoolSource.vue?vue&type=script&lang=js"

import "./DijiaNumberPoolSource.vue?vue&type=style&index=0&id=efc3c83c&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-efc3c83c"

export default script